import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import PIAModal from '../../../@lbs/components/PIA/PIAModal';
import { useAuthUser } from '../../../@lbs/hook/AuthHooks';
import AppErrorBoundary from '../AppErrorBoundary';
import AppFooter from '../AppLayout/components/AppFooter';
import AppSuspense from '../AppSuspense';
import AppContentViewWrapper from './AppContentViewWrapper';

const AppContentView = ({ sxStyle, routes }) => {
  const { user } = useAuthUser();
  const navigate = useNavigate();
  const location = useLocation();

  const [isPiaModalOpen, setIsPiaModalOpen] = useState(false);

  useEffect(() => {
    const isPiaSigned = JSON.parse(
      localStorage.getItem('isPiaSigned') || 'false',
    );

    // Show modal only if not signed and not on '/due-invoice' or its child routes
    if (!isPiaSigned && !location.pathname.startsWith('/due-invoice')) {
      setIsPiaModalOpen(true);
    }
  }, [location.pathname]);

  const handlePiaModalClose = () => {
    localStorage.setItem('isPiaSigned', 'true');
    setIsPiaModalOpen(false);
    // Optional: Add API logic here
  };

  // Check if the user has due invoices and is not already on the '/due-invoice' route
  if (user?.hasDueInvoice && location.pathname !== '/due-invoice') {
    navigate('/due-invoice');
    return null; // Prevent rendering
  }

  return (
    <AppContentViewWrapper>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          p: { xs: 5, md: 7.5, xl: 12.5 },
          ...sxStyle,
        }}
        className='app-content'
      >
        <AppSuspense>
          <AppErrorBoundary>{routes}</AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
      {isPiaModalOpen && !location.pathname.startsWith('/due-invoice') && (
        <PIAModal onClose={handlePiaModalClose} />
      )}
    </AppContentViewWrapper>
  );
};

export default AppContentView;

AppContentView.propTypes = {
  sxStyle: PropTypes.object,
  children: PropTypes.node,
  routes: PropTypes.object.isRequired,
};
